import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { isEqual, keyBy } from "lodash";
import { DynamicDataObk, Graph_QL } from "../..";
import { AttentionLog } from "./GQLCalls/getAttentionLogs";



export type AttentionLogItem = DynamicDataObk<AttentionLog[]>

const attentionLogDataAdapter = createEntityAdapter({
  selectId: (item: AttentionLogItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<AttentionLogItem, string>, {con, data}: AttentionLogItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "attention_log_id");
    data.forEach((entry) => dataDictionary[entry.attention_log_id] = entry);
    const newPayload = {con, data: Object.values(dataDictionary)};
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      attentionLogDataAdapter.upsertOne(state, newPayload);
    }
  } else { attentionLogDataAdapter.addOne(state, {con, data})}
}

const attentionLogSlice = createSlice({
  name: "attentionLogs",
    initialState: attentionLogDataAdapter.getInitialState(),
      reducers: {
        maintained: (state, {payload}:PayloadAction<AttentionLogItem>) => {
          mergePayloadAndState(state, payload);
        }
    }
})

export const attentionLogActions = attentionLogSlice.actions;
export default attentionLogSlice.reducer;